import { Data2, newId, dateToString } from '../../../features/data-types'
import { DataTypeEvent } from '../../../features/events'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { DeliveryData, DeliveryStatus } from '../../deliveries'
import { FiscalDocumentStatus, Perception } from '../../fiscal-documents'
import { Item, PaymentStatus } from '../../operations'
import { useSystemStateHooks } from '../../system'
import { HoardInvoiceStats, HoardOrder, HoardPriceCorrection, HoardType, InternalNote, InvoiceInFlight, PricesList, SalePaymentItem, SpecialDiscountItem } from '../state/types'

export const useHoardBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildHoard = (data: Data2) => {
        const {
            id = newId(),
            code,
            type,
            value,
            unusedCredit,
            vatTaxYield,
            creationDate,
            dueDate,
            items,
            paymentTypeId,
            paymentTypeYield,
            paymentItems,
            paidAmount,
            receivedAmount,
            overpaidAmount,
            adjustedAmount,
            sellerId,
            customerId,
            customerTypeId,
            initialCredit,
            deliveryData,
            deliveryStatus,
            paymentStatus,
            invoiceStatus,
            invoiceStats,
            invoiceInFlight,
            pricesList,
            priceCorrections,
            branchId,
            latePayment,
            notes,
            specialDiscountItems,
            events,
            perceptions,
            internalNotes,
            cancelled,
            archived
        } = data

        const hoard: HoardOrder = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            codeStr: code!.toString()!,
            type: type! as HoardType,
            value: value as O<number>,
            unusedCredit: unusedCredit as O<number>,
            vatTaxYield: vatTaxYield as O<number>,
            creationDate: dateToString(creationDate || new Date())!,
            dueDate: dateToString(dueDate)!,
            items: (items || []) as Item[],
            currency: Currency.ARS,
            paymentTypeId: paymentTypeId! as string,
            paymentTypeYield: paymentTypeYield! as number,
            paymentItems: (paymentItems || []) as SalePaymentItem[],
            paidAmount: (paidAmount || 0) as number,
            receivedAmount: receivedAmount as O<number>,
            overpaidAmount: overpaidAmount as O<number>,
            adjustedAmount: adjustedAmount as O<number>,
            sellerId: sellerId! as string,
            customerId: customerId! as string,
            customerTypeId: customerTypeId! as string,
            initialCredit: initialCredit as O<number>,
            deliveryData: deliveryData as O<DeliveryData>,
            deliveryStatus: (deliveryStatus || DeliveryStatus.PENDING) as DeliveryStatus,
            paymentStatus: (paymentStatus || PaymentStatus.PENDING) as PaymentStatus,
            invoiceStatus: (invoiceStatus || FiscalDocumentStatus.PENDING) as FiscalDocumentStatus,
            invoiceStats: invoiceStats as O<HoardInvoiceStats>,
            invoiceInFlight: invoiceInFlight as O<InvoiceInFlight>,
            pricesList: pricesList! as PricesList,
            priceCorrections: priceCorrections as O<HoardPriceCorrection[]>,
            branchId: branchId! as string,
            latePayment: !!latePayment as boolean,
            notes: notes as O<string>,
            specialDiscountItems: specialDiscountItems as O<SpecialDiscountItem[]>,
            events: (events || []) as DataTypeEvent[],
            perceptions: (perceptions || []) as Perception[],
            internalNotes: (internalNotes || []) as InternalNote[],
            cancelled: !!cancelled,
            archived: !!archived
        }

        return hoard
    }

    return {
        buildHoard
    }
}
